import Application from '@ember/application';
import Resolver from 'ember-resolver';
import loadInitializers from 'ember-load-initializers';
import config from 'pds-witsmlstudio-store/config/environment';
import { setBuildURLConfig } from '@ember-data/request-utils';
import '@warp-drive/ember/install';
import 'pds-witsmlstudio-core/icons';
import 'pds-witsmlstudio-store/app.css';

config.rootURL = document.querySelector('meta[name="urlPathBase"]').content;

setBuildURLConfig({
  namespace: 'api',
});

export default class App extends Application {
  modulePrefix = config.modulePrefix;
  podModulePrefix = config.podModulePrefix;
  Resolver = Resolver;
}

loadInitializers(App, config.modulePrefix);
